import React from "react";
import { Switch } from "antd";
import { Fold } from "./Fold";

export function OptionRow({
  id,
  title,
  subtitle,
  checked,
  onChange,
  open,
  children,
}) {
  return (
    <section className={`md-opt${checked ? " is-on" : ""}`}>
      <div className="md-opt-top">
        <div>
          <b id={id}>{title}</b>
          <span>{subtitle}</span>
        </div>
        <Switch checked={checked} onChange={onChange} aria-labelledby={id} />
      </div>
      <Fold open={open}>
        <div className="md-opt-body">{children}</div>
      </Fold>
    </section>
  );
}
